import styles from './ComponentEmployeeBlock.module.scss';
import { useEffect, useState } from 'react';

import { EmployeeCardProps, EmployeeCardBlock } from '@/types';
import { useScrollLock, useWindowSize } from '@/ui/hooks';
import { Modal } from '@/ui/base';

import { EmployeeCard } from './EmployeeCard';
import { EmployeeBio } from './EmployeeBio';

const ComponentEmployeeBlock = ({
  employeeBlockHeading,
  employeeCards,
}: EmployeeCardBlock) => {
  const [isOpen, setIsOpen] = useState(false);
  const [blockScroll, allowScroll] = useScrollLock();
  const windowSize = useWindowSize();

  const [selectedCard, setSelectedCard] = useState<EmployeeCardProps | null>(
    null
  );

  const [modalTriggerId, setModalTriggerId] = useState<string>('');

  const hasHeading = !!employeeBlockHeading;

  const handleModalClose = () => {
    setIsOpen(false);
    allowScroll();
    setSelectedCard(null);
  };

  const handleCardClick = (card: EmployeeCardProps, id: string) => {
    setSelectedCard(card);
    setModalTriggerId(id);
    setIsOpen(true);
    blockScroll();
  };

  useEffect(() => {
    // modal is closed on window resize, but scroll is still blocked so we must allow it
    allowScroll();
  }, [windowSize]);

  return (
    <section className={styles.employeeBlock}>
      <div className={styles.employeeBlock__inner}>
        {hasHeading && (
          <div className={styles.employeeBlock__top}>
            <h2 className={styles.employeeBlock__heading}>
              {employeeBlockHeading}
            </h2>
          </div>
        )}
        <div className={styles.employeeBlock__grid}>
          {employeeCards?.map((card: EmployeeCardProps, index: number) => {
            const id = `card-${card.sys?.id}_${index}`;
            return (
              <EmployeeCard
                key={id}
                id={id}
                onCardClick={() => handleCardClick(card, id)}
                {...card}
              />
            );
          })}
        </div>
      </div>
      <Modal
        handleClose={() => handleModalClose()}
        isOpen={isOpen}
        triggerId={modalTriggerId}
        isLarge
        fullContent
      >
        <div className={styles.employeeBlock__modalContainer}>
          {selectedCard && <EmployeeBio cardInfo={selectedCard} />}
        </div>
      </Modal>
    </section>
  );
};

export default ComponentEmployeeBlock;
